import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { ResponsiveDisplayConstants } from '@ddt-web/dom';

import { BlendingAccordionPanelComponent } from '../blending-accordion-panel/blending-accordion-panel.component';


@Component({
	selector: 'ac-blending-accordion',
	templateUrl: './blending-accordion.component.html',
	styleUrls: ['./blending-accordion.component.scss']
})
export class BlendingAccordionComponent implements AfterContentInit {
	@Input() public exclusive: boolean = false;
	@Input() public isExpanded: boolean = false;
	@Input() public isCollapsedOnMobile: boolean = true;
	@Input('custom-classes') public customClasses: string = '';
	@ContentChildren(BlendingAccordionPanelComponent) public panels: QueryList<BlendingAccordionPanelComponent>;

	public ngAfterContentInit(): void {
		this.panels.toArray().forEach((panel: BlendingAccordionPanelComponent) => {
			if (this.isExpanded) {
				panel.isCollapsed = false;
			}
			panel.onToggleChange.subscribe(() => {
				this.togglePanel(panel);
			});
		});
		this.collapseOnMobile();
	}

	private togglePanel(panel: BlendingAccordionPanelComponent): void {
		if (this.exclusive) {
			this.panels.toArray().forEach(pane => {
				if (pane !== panel) {
					pane.isCollapsed = true;
				}
			});
		}
		panel.isCollapsed = !panel.isCollapsed;
	}

	private collapseOnMobile(): void {
		if (this.isCollapsedOnMobile && window.innerWidth <= ResponsiveDisplayConstants.DEVICE_WIDTH.MOBILE_MAX) {
			this.panels.toArray().forEach(pane => {
				pane.isCollapsed = true;
			});
		}
	}
}
